import clsx from 'clsx'

export function Label({
  children,
  className,
  ...props
}: React.LabelHTMLAttributes<HTMLLabelElement>) {
  return (
    <label
      className={clsx('block text-sm/6 font-medium text-gray-950', className)}
      {...props}
    >
      {children}
    </label>
  )
}
